<script>
import {getUser, NoCurrentUserError} from '@simpleinvest/front-end-auth';
import {UserType} from '@digital-advice/ms-core-sdk';
import {setUser} from '@simpleinvest/front-end-logger';
import {mapState, mapActions} from 'vuex';
import exceptionHandler from '@advisor/util/exceptionHandler';

export default {
  name: 'App',
  components: {
    AdvHeader: () => import('@advisor/components/layout/Header'),
    AdvFooter: () => import('@advisor/components/layout/Footer'),
    AdvView: () => import('@advisor/components/layout/View'),
    Notification: () => import('@advisor/components/Notification'),
    AdvLogoutModal: () => import('@advisor/components/AdvLogoutModal'),
    AdvWorker: () => import('@advisor/components/common/AdvWorker'),
  },
  props: {
    // eslint-disable-next-line vue/no-unused-properties
    source: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    isGuarded: null,
    isRiaOnboarding: false,
    steps: [],
  }),
  computed: {
    ...mapState({
      settings: (state) => state.settings,
      notification: (state) => state.notification.current,
    }),
    appFonts() {
      return {
        'font-family': this.settings.ria.fontFamily,
        'font-size': this.settings.ria.fontSize,
      };
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route() {
      this.isGuarded = !this.$route.meta.unguarded;
      this.isRiaOnboarding = this.$route.meta.module === 'ria-onboarding';
    },
  },
  async created() {
    this.loadOptions();

    try {
      const user = await getUser();

      this.setUser(user);
      setUser({
        enterpriseId: user.enterpriseId,
        userId: user.userId,
        riaId: user.riaId,
        userType: UserType.RiaUser,
      });
    } catch (error) {
      if (!(error instanceof NoCurrentUserError)) {
        exceptionHandler.handleGenericException('App.created()', error);
      }
    }
  },
  methods: {
    ...mapActions('rwOptions', ['loadOptions']),
    ...mapActions('cognitoUser', ['setUser']),
    onClick() {
      if (this.isGuarded && this.$refs.logoutModal) {
        this.$refs.logoutModal.reset();
      }
    },
  },
};
</script>

<template>
  <!-- eslint-disable-next-line vue-a11y/click-events-have-key-events -->
  <div data-test-id="onClick" class="appwrapper" @click="onClick">
    <v-app :style="appFonts">
      <Notification v-if="notification" :message="notification" />
      <AdvWorker />
      <!-- header -->
      <AdvHeader v-if="isGuarded" />

      <!-- main -->
      <AdvView />

      <!-- footer -->
      <AdvFooter v-if="isGuarded || isRiaOnboarding" />
      <AdvLogoutModal v-if="isGuarded" ref="logoutModal" />
    </v-app>
  </div>
</template>

<style lang="scss" scoped>
.appwrapper ::v-deep {
  font-size: 1em;
  .v-window {
    overflow: initial;
  }
}
.v-alert {
  width: 100%;
  z-index: 1000;
  position: fixed;
}
</style>
